/** @format */
import React, { FC, forwardRef, useMemo, useRef, useState, useImperativeHandle } from 'react'
import { _$, Icon, Message, Select, Option } from '@king-design/react'
import styled from 'styled-components'
import _ from 'lodash'

interface valueOptions {
  label?: string | number
  value?: string | number
  key?: string | number
}
interface options {
  label?: string
  value?: string
}

interface dimensList {
  key?: string
  value?: string | number
  hide?: boolean
}

const CustomMonitorDimens: FC<any> = forwardRef(
  ({ className, dimensionList = [], defaultDimensData }, ref) => {
    const [dimenslist, setDimensList] = useState<dimensList[]>([])
    const keys = useRef<options[]>([])
    const values = useRef<valueOptions[]>([])
    // 添加维度
    const addDimensList = () => {
      if (dimensionList?.length > 0) {
        const accCount = dimensionList?.length
        const accItem = dimensionList(accCount - 1)
        if (accItem?.key && !accItem?.value) return
      }
      setDimensList(state => state.concat({ key: '', value: '' }))
    }
    // 删除维度
    const deleteDimensItem = index => {
      const dimensList = _.cloneDeep(dimenslist)
      dimensList[index].hide = true
      // const filterList = dimensList.filter((el, i) => i !== index)
      setDimensList(dimensList)
    }
    // 维度值变更
    const resetItemValue = (index, newValue) => {
      const { key } = _.cloneDeep(dimenslist)[index]
      const hadItem = dimenslist.filter(i => i.key === key && i?.hide !== true)
      if (hadItem.length > 1 && hadItem.find(i => i.value === newValue)) {
        setDimensList(state => {
          state[index].value = ''
          return [...state]
        })
        return Message.warning(_$('请勿添加相同维度'))
      }
      setDimensList(state => {
        state[index].value = newValue
        return [...state]
      })
    }
    // 维度key变更
    const resetItemKey = (index, newValue) => {
      setDimensList(state => {
        state[index].key = newValue
        return [...state]
      })
    }

    useMemo(() => {
      // 生成可选维度字典表
      if (Array.isArray(dimensionList?.value)) {
        const sourceList = _.cloneDeep(dimensionList?.value)
        const dimensKeys: string[] = sourceList.map(i => i.dimensionKey)
        const dimensList = _.uniq(dimensKeys).map(i => ({ label: i, value: i }))
        keys.current = dimensList
        values.current = sourceList.map(i => ({
          label: i.dimensionValue,
          value: i.dimensionValue,
          key: i.dimensionKey
        }))
      }
      if (!defaultDimensData) return
      const defaultData = defaultDimensData.split(',').map(item => {
        const dimensItem = item.split('=')
        return {
          key: dimensItem[0],
          value: dimensItem[1]
        }
      })
      setDimensList(defaultData)
    }, [dimensionList])

    useImperativeHandle(ref, () => ({
      getDimensData: () => dimenslist.filter(i => !i?.hide)
    }))

    return (
      <div className={className}>
        {dimenslist.map((el, index) =>
          !el?.hide ? (
            <div key={el.key + index}>
              <div className="form-item">
                <Select
                  container={dom => dom.parentElement}
                  filterable
                  value={el.key}
                  onChangeValue={domain => resetItemKey(index, domain)}
                >
                  {keys.current &&
                    keys.current.map(i => (
                      <Option value={i?.value} key={i?.value}>
                        {_$(i?.label)}
                      </Option>
                    ))}
                </Select>
                <Select
                  container={dom => dom.parentElement}
                  value={el.value}
                  onChangeValue={value => resetItemValue(index, value)}
                >
                  {values.current &&
                    values.current
                      .filter(i => i.key === el.key)
                      .map(i => (
                        <Option value={i?.value} key={i?.value}>
                          {_$(i?.label)}
                        </Option>
                      ))}
                </Select>
                <a className="delete-btn" onClick={() => deleteDimensItem(index)}>
                  {_$('删除')}
                </a>
              </div>
              {el.key && !el.value ? <p className="error">{_$('请选择维度值')}</p> : null}
            </div>
          ) : null
        )}

        <p>
          <a onClick={() => addDimensList()}>
            <Icon color="#0091ea" className="ion-plus-round"></Icon>
            {_$('添加维度')}
          </a>
        </p>
      </div>
    )
  }
)
export default styled(CustomMonitorDimens)`
  .form-item {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    .delete-btn {
      margin-left: 16px;
    }
  }
  .k-input,
  .k-select {
    width: 40%;
  }
  .ion-plus-round {
    font-size: 12px;
    margin-right: 5px;
  }
  .error {
    color: red;
  }
`
